module.exports = __webpack_public_path__ + "img/link-banner-ar.e740eb0c.png";